import { Component, ComponentInterface, Element, Event, EventEmitter, h, Host, JSX, Listen, Method, Prop, Watch } from '@stencil/core';
import { SharedDirectionService } from '../../global/workbench-global';
import { getDataOnFromTheme, WorkbenchTheme } from '../../shared/themes';
import { FlyInPosition } from './fly-in.types';

/**
 * @slot - Contents of the fly-in
 **/
@Component({
  tag: 'wb-fly-in',
  styleUrl: 'fly-in.scss',
  shadow: true,
})
export class FlyInComponent implements ComponentInterface {
  @Element()
  public el: HTMLElement;

  /**
   * Colour scheme
   * @deprecated Use `data-on` attribute instead
   * */
  @Prop({ reflect: true })
  public theme: WorkbenchTheme;

  /** side from which the component flies in  */
  @Prop({ reflect: true })
  public from: FlyInPosition = 'end';

  /** set to true to make component fly in */
  @Prop({ reflect: true, mutable: true })
  public open: boolean = false;

  /** set to true to hide backdrop when fly-in is open */
  @Prop({ reflect: true })
  public hideBackdrop: boolean = false;

  /** Makes fly-in have recommended padding */
  @Prop({ reflect: true })
  public padded: boolean = false;

  /** @internal if present sets the direction of the element to rtl */
  @Prop({ reflect: true, mutable: true })
  public isRtl: boolean = false;

  /** Event emitted when fly-in closes */
  @Event({ bubbles: true })
  public wbclose!: EventEmitter<null>;

  /** toggles the fly-out between open and closed */
  @Method()
  public async toggle(): Promise<void> {
    this.open = !this.open;
  }

  @Listen('wbdirchange', { target: 'document' })
  public updateDirection() {
    this.isRtl = SharedDirectionService.isRtl;
  }

  @Watch('open')
  public async handleOpenChange(): Promise<void> {
    if (!this.open) {
      this.wbclose.emit();
    }
  }

  public connectedCallback(): void {
    this.updateDirection();
  }

  public render(): JSX.Element {
    return (
      <Host class="wb-fly-in" role="dialog" data-on={getDataOnFromTheme(this.el, this.theme)}>
        <slot />
      </Host>
    );
  }
}
